// src/hooks/useAddLanguagesModal.tsx
import useUiStore from "../store/useUiStore.ts";
import AddLanguagesModal from "../components/AddLanguages/AddLanguagesModal.tsx";
import {IProject} from "../models/interfaces/project.interface.ts";

/**
 * Opens the "Add Languages" dialog for an existing project.
 *
 * Same `openModal` shape as `useCreateNewProjectModal`, but deliberately narrower: this dialog
 * holds one picker and a cost line, so the create wizard's `max-w-[48rem]` would leave the
 * content stranded in the middle of an oversized sheet.
 */
export const useAddLanguagesModal = () => {
  const {openModal} = useUiStore();

  return (project: IProject) => {
    openModal(
      <AddLanguagesModal project={project}/>,
      {
        // Never add `overflow-hidden`: this className skips twMerge, so it beat the Dialog's own
        // `overflow-auto` and killed wheel scrolling, stranding the footer once ~6 languages were
        // picked. Same trap that had to be undone in useCreateNewProjectModal.
        className: "md:!p-0",
        // `max-h` + `flex flex-col` are load-bearing: they let the dialog's middle section own the
        // scroll so the footer stays pinned. `3rem` is the Dialog's `p-6` on both edges.
        classWrap: "max-w-[34rem] max-h-[calc(100vh-3rem)] flex flex-col md:h-[100dvh] md:max-h-[100dvh] md:rounded-none",
        classButtonClose: "hidden md:block md:absolute md:top-5 md:right-5 dark:fill-n-400",
        classOverlay: "md:bg-n-100",
      }
    );
  };
};
